import { type Event, createEvent } from 'models';
import { useQuery } from 'query';
import { getNodeEvent } from '../services';
import { getNodeEventEnterQueryKey } from './keys';

export const useNodeEventByInvitationTokenQuery = (
  { eventId, invitationToken }: { eventId: string; invitationToken: string },
  options?: { throwOnError?: boolean },
) =>
  useQuery<Event>({
    async queryFn() {
      const { data: event } = await getNodeEvent({
        config: {
          headers: {
            authorization: `Bearer ${invitationToken}`,
          },
          skipAuth: true,
        },
        routeParams: { id: eventId },
      });

      return createEvent(event);
    },
    queryKey: getNodeEventEnterQueryKey({ eventId, invitationToken }),
    throwOnError: true,
    ...options,
  });
